import TextField from '@mui/material/TextField'
import {useFormContext} from 'react-hook-form'
import PropTypes from 'prop-types'

const Input = ({label, name, type = 'text', options = {}, hideLabel, ...props}) => {
  const {register} = useFormContext()

  return (
    <TextField
      autoComplete='off' label={hideLabel ? '' : (label || name)}
      variant='outlined' type={type}
      sx={{'& label': {color: '#71B1AE'}}}
      {...register(name, options)}
      {...props}
    />
  )
}

Input.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.object,
  type: PropTypes.string
}

export default Input
